/*
 * Public API Surface of oang-material
 */

export * from './lib/oang-material.module';
export * from './lib/field-text/index';
